import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {LocalStorageService} from 'ngx-webstorage';
import 'rxjs/add/observable/of';

import { environment } from '../../environments/environment';

@Injectable()
export class CategoryService {

  private serverUrl = environment.serverUrl;
  private serviceUrl = 'categories';

  constructor(private http: HttpClient, private localSt: LocalStorageService) {}

  // list(data): Observable<any> {
  //   let reqObj = `?page=${data.page}&limit=${data.limit}&order=${data.order}`;
  //   if (data.search) {
  //     reqObj += '&search=${data.search}';
  //   }
  //   if (data.sort) {
  //     reqObj += '&sort=${data.sort}';
  //   }
  //   return this.http.get(this.serverUrl + this.serviceUrl + reqObj);
  // }

  list(data): Observable<any> {
    return this.http.put(this.serverUrl + 'categories/withactivefeatures', {date: data.date});
  }

  aboutUs(): Observable<any> {
    return this.http.get(this.serverUrl + 'aboutus');
  }

}



// WEBPACK FOOTER //
// ./src/app/services/category.service.ts